(function() {
    'use strict';

    angular.module('app').directive('autocompleteAddress', autocompleteAddress);

    function autocompleteAddress() {
        return {
            restrict: 'A',
            link: link,
            scope: {address: '='}
        };

        function link($scope, $element, $attrs) {
            $element.ready(apply);

            function apply() {

                var componentForm = {
                    street_number: 'short_name',
                    route: 'long_name',
                    locality: 'long_name',
                    administrative_area_level_1: 'short_name',
                    country: 'long_name',
                    postal_code: 'short_name',
                    administrative_area_level_2: 'short_name',
                    postal_town : 'short_name'
                };

                initAutocomplete();    

                function initAutocomplete() {
                    // Create the autocomplete object, restricting the search to geographical
                    // location types.
                    var autocomplete = new google.maps.places.Autocomplete(
                        ($element.find('.autocomplete')[0]), {
                            types: ['geocode']
                        });

                    // When the user selects an address from the dropdown, populate the address
                    // fields in the form.
                    autocomplete.addListener('place_changed', fillInAddress);

                    // [START region_fillform]
                    function fillInAddress() {
                        // Get the place details from the autocomplete object.
                        var place = autocomplete.getPlace();

                        var address = [];
                        //for (var component in componentForm) {
                         //   if (componentForm.hasOwnProperty(component)) {
                          //      $element.find('.' + component).val('');
                          //      $element.find('.' + component).prop('disabled', false);
                          //  }
                        //}

                        // Get each component of the address from the place details
                        // and fill the corresponding field on the form.
                        for (var j = 0; j < place.address_components.length; j++) {
                            var addressType = place.address_components[j].types[0];
                            if (componentForm[addressType]) {
                                var val = place.address_components[j][componentForm[addressType]];
                                //$element.find('.' + addressType).val(val);
                                address[addressType] = val;
                            }
                        }
                        $scope.address.line1 = address['street_number'] + ' ' + address['route'];
                        $scope.address.city = (address['locality'])? address['locality'] : address['administrative_area_level_2'];
                        $scope.address.state = address['administrative_area_level_1'];
                        $scope.address.postalCode = address['postal_code'];
                        $scope.address.country = address['country'];
                        if(address['street_number'] !== 'undefined')
                        {
                            $scope.$apply();
                        }

                    }
                    // [END region_fillform]
                }
            }
        }
    }

})();
